import { Fragment } from 'react';

import { PartnerService as Service } from './PartnerService';

import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';
import { useDialogCrup } from '../../../shared/hooks/DialogCrup';
import { useImExExcel } from '../../../shared/hooks/ImExExcel';
import { Button } from 'primereact/button';
import { MGateWayService } from '../../lich-su-truyen-nhan/MGateWayService';
import { ToastService } from '../../../AppToast';

export const List = () => {

  const header = 'Danh mục đối tác';
  const dataKey = 'id';

  const { render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems, dataTableParams } = useDataTable({
    header,
    dataKey,
    columns: [
      { field: 'code', header: 'Mã đối tác', width: 160, matchMode: 'contains' },
      { field: 'name', header: 'Tên đối tác', minWidth: 200, matchMode: 'contains' },
      { field: 'taxCode', header: 'Mã số thuế', width: 140, matchMode: 'contains' },
      { field: 'address', header: 'Địa chỉ', minWidth: 200, matchMode: 'contains' },
      { field: 'qualityNo', header: 'Tiêu chuẩn', width: 140, matchMode: 'contains' },
      { field: 'personContact', header: 'Người liên hệ', width: 180, matchMode: 'contains' },
      { field: 'tel', header: 'Số điện thoại', width: 180, matchMode: 'contains' },
    ],
    actionColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });


  const searchTaxCode = () => {
    const { taxCode, } = getValue();
    if (taxCode) {
      MGateWayService.searchTaxCode(taxCode).then(data => {
        console.log(data)
        if (data) {
          setValue({
            code: data.masothue_id || '',
            taxCode: data.ma_so_thue || '',
            name: data.ten_cty || '',
            personContact: data.nguoi_dai_dien || '',
            address: data.dia_chi || ''
          });
        } else {
          ToastService.error('Không tìm thấy dữ liệu');
        }
      });
    }
  }

  const { render: renderDialogCrup, create, update, clone, getValue, setValue } = useDialogCrup({
    header,
    dataKey,
    width: '40rem',
    fields: [
      { field: 'code', header: 'Mã đối tác', required: true, uppercase: true, InputTextProps: { maxLength: 3 }, className: 'md:col-4' },
      { field: 'taxCode', header: 'Mã số thuế', required: true, className: 'md:col-7' },
      {
        type: 'custom', className: 'md:col-1', body: (
          <div className="mt-4">
            <Button icon="pi pi-search" className="p-button-rounded p-button-outlined" onClick={searchTaxCode} />
          </div>
        )
      },
      { field: 'name', header: 'Tên đối tác', required: true, InputTextProps: { maxLength: 50 }, className: 'md:col-12' },
      { field: 'qualityNo', header: 'Tiêu chuẩn', required: true, className: 'md:col-12' },
      { field: 'address', header: 'Địa chỉ', className: 'md:col-12' },
      { field: 'personContact', header: 'Người liên hệ', className: 'md:col-6' },
      { field: 'tel', header: 'Số điện thoại', className: 'md:col-6' },
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const { renderImExExcel, download, showImportDialog } = useImExExcel({
    exportTemplate: () => {
      return Service.downloadExcelTemplate();
    },
    exportExcel: (params) => {
      return Service.downloadExcel(params);
    },
    exportExcelFileName: 'danh-muc-doi-tac',
    importExcel: (data) => {
      return Service.uploadExcel(data);
    },
    reloadLazyData
  });

  const { renderToolbar } = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    showImportDialog,
    exportExcel: download, dataTableParams,
    deleteItem: (id) => {
      return Service.delete(id);
    }
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
      {renderImExExcel()}
    </Fragment>
  )
}
